import { lazy, Suspense } from 'react';
import { useSession } from '@/stores/session';
import { PageSkeleton } from '@/components/system/LazyPage';

// 2-nov (react-best-practices, bundle-conditional): cada portada viaja en su
// propio chunk; antes las tres iban en el de entrada para todos los roles.
const PlatformPage = lazy(() => import('@/features/platform/PlatformPage').then((m) => ({ default: m.PlatformPage })));
const ClientHomePage = lazy(() => import('@/features/client/ClientHomePage').then((m) => ({ default: m.ClientHomePage })));
const DashboardPage = lazy(() => import('@/features/dashboard/DashboardPage').then((m) => ({ default: m.DashboardPage })));

/** La portada depende del rol: plataforma (súper admin) · consola (firma) · portal (cliente). */
export function RoleHome() {
  const role = useSession((s) => s.role);
  return (
    <Suspense fallback={<PageSkeleton />}>
      {role === 'super_admin' ? <PlatformPage /> : role === 'client' ? <ClientHomePage /> : <DashboardPage />}
    </Suspense>
  );
}
